import { axiosInstance } from "../../../utils";
import _ from "lodash";

const actions = {
  CREATE_OR_UPDATE_GIFT_REQUESTED: "CREATE_OR_UPDATE_GIFT_REQUESTED",
  CREATE_OR_UPDATE_GIFT_SUCCEEDED: "CREATE_OR_UPDATE_GIFT_SUCCEEDED",
  CREATE_OR_UPDATE_GIFT_FAILED: "CREATE_OR_UPDATE_GIFT_FAILED",

  addOrUpdateGift: (data = undefined) => {
    return {
      type: actions.CREATE_OR_UPDATE_GIFT_REQUESTED,
      payload: data,
    };
  },

  createOrUpdateGift: async (data = undefined) => {
    let url = `gifts/create`;
    let bodyFormData = new FormData();

    if (data.name) bodyFormData.set("name", data.name);
    if (data.name_ar) bodyFormData.set("name_ar", data.name_ar);
    if (data.barcodes)
      bodyFormData.set("barcodes", JSON.stringify(data.barcodes));
    if (data.brand_path)
      bodyFormData.set("brand_path", JSON.stringify(data.brand_path));

    if (data.description) bodyFormData.set("description", data.description);
    if (data.description_ar)
      bodyFormData.set("description_ar", data.description_ar);
    if (data.pack_size) bodyFormData.set("pack_size", data.pack_size);
    if (data.color) bodyFormData.set("pack_size", data.color);
    bodyFormData.set("quantity", data.quantity ?? 0);
    bodyFormData.set("is_active", data.is_active ? true : false);

    if (data.images) {
      let images = [];

      for (let i = 0; i < data?.images.length; i++) {
        if (data.images[i].originFileObj) {
          bodyFormData.append("images", data.images[i].originFileObj);
        } else {
          images.push(data.images[i].url);
        }
      }
      console.log(images, "imagesimages");
      bodyFormData.append("images_urls", JSON.stringify(images));
    }
    if (data.fields) bodyFormData.set("fields", JSON.stringify(data.fields));
    if (data.pack_size) bodyFormData.set("pack_size", data.pack_size);
    if (data.pack_size_ar) bodyFormData.set("pack_size_ar", data.pack_size_ar);

    if (data._id) {
      url = `gifts/` + data._id;
      try {
        const gift = await axiosInstance.put(url, bodyFormData);
        return gift.data;
      } catch (error) {
        throw error;
      }
    } else {
      if (data.fields) bodyFormData.set("fields", JSON.stringify(data.fields));
      try {
        const gift = await axiosInstance.post(url, bodyFormData);

        return gift.data;
      } catch (error) {
        throw error;
      }
    }
  },
};

export default actions;
